import { Box, MenuItem } from 'shared';

import { ChatMessageMoreActionsMenu } from 'features/chat/components/MoreActionsMenu';

type ScheduledChatMessageMenuProps = {
  onMessageSendNow: () => void;
  onConfirmMessageDelete: () => void;
  onMessageReschedule: () => void;
  onCopyToClipboard: () => void;
  onTextEdit: () => void;
};

const SCHEDULE_LIST_HEADER_HEIGHT = '32px';

export const ScheduledChatMessageActionsMenu = ({
  onMessageSendNow,
  onConfirmMessageDelete,
  onMessageReschedule,
  onCopyToClipboard,
  onTextEdit,
}: ScheduledChatMessageMenuProps) => {
  return (
    <Box
      display="inline-block"
      position="sticky"
      bottom="0"
      top={SCHEDULE_LIST_HEADER_HEIGHT}
    >
      <ChatMessageMoreActionsMenu>
        <MenuItem onClick={onMessageSendNow}>Send now</MenuItem>
        <MenuItem onClick={onMessageReschedule}>Reschedule</MenuItem>
        <MenuItem onClick={onTextEdit}>Edit</MenuItem>
        <MenuItem onClick={onCopyToClipboard}>Copy</MenuItem>
        <MenuItem color="var(--fgDanger)" onClick={onConfirmMessageDelete}>
          Delete
        </MenuItem>
      </ChatMessageMoreActionsMenu>
    </Box>
  );
};
